import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  setNipleOperationOperations: ["operations"],
  setNipleOperationGroupSeconds: ["groupSeconds"]
});

/**
 * Handlers
 */
const INITIAL_STATE = {
  operations: ["D"],
  groupSeconds: 0
};

const setNipleOperationOperations = (state = INITIAL_STATE, action) => {
  const { operations } = action;
  return {
    ...state,
    operations
  };
};

const setNipleOperationGroupSeconds = (state = INITIAL_STATE, action) => {
  const { groupSeconds } = action;
  return {
    ...state,
    groupSeconds
  };
};

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.SET_NIPLE_OPERATION_OPERATIONS]: setNipleOperationOperations,
  [Types.SET_NIPLE_OPERATION_GROUP_SECONDS]: setNipleOperationGroupSeconds
});
